import { Skeleton } from '@/components/ui/skeleton'

export function ChartSkeleton({ className }: { className?: string }) {
  return (
    <div className={className}>
      <Skeleton className="h-[300px] w-full" />
    </div>
  )
} 